import { lazy } from "react";

import { type IntersectionOptions } from "react-intersection-observer";

import { resolveZonePlaceholder } from "./placeholder";

const cartZone = {
  name: "cart",
  query: "#cart",
  settingsQuery: "[data-section-id]",
  hydrate: true,
  component() {
    return lazy(() =>
      import(
        /* webpackExclude: /Placeholder|fixtures|stories|test|\.liquid$/ */
        /* webpackMode: "lazy-once" */
        "@react/sections/Cart"
      ).then((module) => ({
        default: module.CartProvider,
      }))
    );
  },
  placeholder: null,
  observerSettings: {
    delay: 0,
    trackVisibility: false,
  } satisfies IntersectionOptions,
};

const productHeroZone = {
  name: "snippet",
  query: '[id^="tbsp-product"][id$="-snippet"]',
  settingsQuery: "[data-snippet]",
  hydrate: true,
  component(componentName: string) {
    return lazy(() =>
      import(
        /* webpackExclude: /Placeholder|fixtures|stories|test|\.liquid$/ */
        /* webpackMode: "lazy" */
        `@react/sections/ProductHero/${componentName}`
      ).then((module) => {
        return {
          default: module[componentName],
        };
      })
    );
  },
  placeholder(componentName: string, data?: Record<string, unknown>) {
    return resolveZonePlaceholder(componentName, data);
  },
  observerSettings: {
    delay: 0,
    initialInView: true,
    skip: true,
    trackVisibility: false,
  } satisfies IntersectionOptions,
};

const collectionZone = {
  name: "snippet",
  query: '[id^="tbsp-collection"]',
  settingsQuery: "[data-section-id]",
  hydrate: true,
  component(componentName: string) {
    return lazy(() =>
      import(
        /* webpackExclude: /Placeholder|fixtures|stories|test|\.liquid$/ */
        /* webpackMode: "lazy" */
        `@react/sections/Collection/${componentName}`
      ).then((module) => {
        return {
          default: module[componentName],
        };
      })
    );
  },
  placeholder(componentName: string, data?: Record<string, unknown>) {
    return resolveZonePlaceholder(componentName, data);
  },
  observerSettings: {
    delay: 0,
    initialInView: true,
    skip: true,
    trackVisibility: false,
  } satisfies IntersectionOptions,
};

const modalZone = {
  name: "modal",
  query: '[id^="tbsp-"][id$="-modal"]',
  settingsQuery: "[data-snippet]",
  hydrate: true,
  component(componentName: string) {
    return lazy(() =>
      import(
        /* webpackExclude: /Placeholder|fixtures|stories|test|\.liquid$/ */
        /* webpackMode: "lazy" */
        `@react/sections/ModalProvider/${componentName}`
      ).then((module) => {
        return {
          default: module[componentName],
        };
      })
    );
  },
  placeholder: null,
  observerSettings: {
    delay: 0,
    trackVisibility: false,
  } satisfies IntersectionOptions,
};

const countrySelectorModalZone = {
  name: "country-selector-modal",
  query: "#tbsp-country-selector",
  settingsQuery: "[data-section-id]",
  hydrate: true,
  component() {
    return lazy(() =>
      import(
        /* webpackExclude: /Placeholder|fixtures|stories|test|\.liquid$/ */
        /* webpackMode: "lazy-once" */
        `@react/sections/CountrySelectorModal`
      ).then((module) => {
        return {
          default: module.CountrySelectorModal,
        };
      })
    );
  },
  placeholder: null,
  observerSettings: {
    delay: 0,
    initialInView: true,
    skip: true,
    trackVisibility: false,
  } satisfies IntersectionOptions,
};

const sectionZone = {
  name: "section",
  query: "[data-client-root]",
  settingsQuery: "[data-section-id]",
  hydrate: true,
  component(componentName: string) {
    return lazy(() =>
      import(
        /* webpackExclude: /Placeholder|Cart|Collection|CountrySelectorModal|ProductHero|ModalProvider|fixtures|stories|test|\.liquid$/ */
        /* webpackMode: "lazy" */
        `@react/sections/${componentName}`
      ).then((module) => {
        return {
          default: module[componentName],
        };
      })
    );
  },
  placeholder(componentName: string, data?: Record<string, unknown>) {
    return resolveZonePlaceholder(componentName, data);
  },
  observerSettings: {
    delay: 100,
    trackVisibility: true,
  } satisfies IntersectionOptions,
};

export const zones = [
  cartZone,
  collectionZone,
  countrySelectorModalZone,
  modalZone,
  productHeroZone,
  sectionZone,
];
